(function(){
    'use strict';

    angular.module('elogbooks.helpdesk.sites', [
        'elogbooks.helpdesk.sites.details'
    ]);
})();
